module.exports = __webpack_public_path__ + "static/media/Plus-blue.6c319ddb.svg";